import { displayDate } from '@/lib/dates'

export function membershipRenewalDueLabel(value: string | null) {
  return isNeverRenewalDue(value) ? 'Never' : displayDate(value)
}

export function isNeverRenewalDue(value: string | null) {
  if (!value) return true

  return Number(value.slice(0, 4)) >= 2999
}
